import { render, staticRenderFns } from "./WidgetActions.vue?vue&type=template&id=5d37b546&scoped=true"
import script from "./WidgetActions.vue?vue&type=script&lang=js"
export * from "./WidgetActions.vue?vue&type=script&lang=js"
import style0 from "./WidgetActions.vue?vue&type=style&index=0&id=5d37b546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37b546",
  null
  
)

export default component.exports